import { prop } from 'ramda';

import { compact, unprefix } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { toRichText, toText } from '../fields/text';
import { deprecatedPageEntity } from './internal';

const processMainRewardedInnovation = (data) => {
  const { title, description, link: { uid } = {} } = unprefix('main', data);

  return uid
    ? {
        title: toText(title),
        description: toRichText(description),
        uid: uid,
      }
    : null;
};

const processRewardedInnovationPage = (data) =>
  compact({
    uid: DocumentType.REWARDED_INNOVATION_PAGE,
    type: DocumentType.REWARDED_INNOVATION_PAGE,
    rewardedInnovation: processMainRewardedInnovation(data),
    filters: compact({
      [FILTER.MENU]: MENU.ACTIVITY,
    }),
  });

export const RewardedInnovationPage = deprecatedPageEntity(
  DocumentType.REWARDED_INNOVATION_PAGE,
  {
    processStrategy: (entity) =>
      processRewardedInnovationPage(prop('data', entity)),
  }
);
